var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"review-wrapper p-4"},[_c('img',{staticClass:"mw-100 rounded mb-4",attrs:{"src":_vm.image}}),_vm._v(" "),_c('div',{staticClass:"text-center mb-4"},[_vm._v(_vm._s(_vm.text_message))])])}
var staticRenderFns = []

export { render, staticRenderFns }